export var mapStatistics = function (x) {
    var provider = x.media &&
        x.media.find(function (mediaProvider) { return mediaProvider.mediaType === "Stats" && mediaProvider.providerName === "BetRadarStats"; });
    x.statisticsEventId = provider ? provider.providerEventId : "";
    return x;
};
//# sourceMappingURL=mapStatistics.js.map